import * as actionTypes from "./actionTypes";

const log = require("loglevel").getLogger("MappingActions");
log.setLevel("error");

export const setHasRelatedContacts = (value) => {
  return async (dispatch) => {
    log.debug("MappingActions -> setHasRelatedContacts -> Enter");

    await dispatch({
      type: actionTypes.SET_HAS_RELATED_CONTACTS,
      payload: value,
    });
  };
};

export const setContactRoleCategory = (value) => {
  return async (dispatch) => {
    log.debug("MappingActions -> setContactRoleCategory -> Enter");

    await dispatch({
      type: actionTypes.SET_CONTACT_ROLE_CATEGORY,
      payload: value,
    });
  };
};

export const setContactRoleSegment = (value) => {
  return async (dispatch) => {
    log.debug("MappingActions -> setContactRoleSegment -> Enter");

    await dispatch({
      type: actionTypes.SET_CONTACT_ROLE_SEGMENT,
      payload: value,
    });
  };
};

export const setContactRole = (value) => {
  return async (dispatch) => {
    log.debug("MappingActions -> setContactRole -> Enter");

    await dispatch({
      type: actionTypes.SET_CONTACT_ROLE,
      payload: value,
    });
  };
};

export const resetRelatedContacts = () => {
  return async (dispatch) => {
    log.debug("MappingActions -> resetRelatedContacts -> Enter");

    await dispatch({
      type: actionTypes.RESET_RELATED_CONTACTS,
    });
  };
};
